import PropTypes from "prop-types"
import SingleValueSelector from "./single-value"
import RangeValueSelector from "./range-value"
import SingleDropdownSelector from "./single-select"
import MultiDropdownSelector from "./multi-select"
import SecuritiesDialogSelector from "./securities-dialog-selector"

export default function ValueSelector({ filterOn, operator, values, setValues, setAllValues, handleDelete, searchSecurities, clearSecurities, currency, disabled }) {
  if (!operator) {
    return null
  }

  switch (operator.selectorType) {
    case "none":
      return null
    case "range":
      return <RangeValueSelector values={values} setValues={setValues} dataType={filterOn.dataType} disabled={disabled} />
    case "singleSelect":
      return <SingleDropdownSelector values={values} setValues={setValues} options={filterOn.options} disabled={disabled} />
    case "multiSelect":
      return <MultiDropdownSelector values={values} setValues={setAllValues} options={filterOn.options} disabled={disabled} />
    case "securitiesSearch":
      return <SecuritiesDialogSelector
        values={values}
        handleDelete={handleDelete}
        searchSecurities={searchSecurities}
        clearSecurities={clearSecurities}
        disabled={disabled}
      />
    default:
      return <SingleValueSelector values={values} setValues={setValues} dataType={filterOn.dataType} currency={currency} disabled={disabled} />
  }
}

ValueSelector.propTypes = {
  filterOn: PropTypes.object,
  operator: PropTypes.object,
  values: PropTypes.array,
  currency: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  setAllValues: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  searchSecurities: PropTypes.func.isRequired,
  clearSecurities: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
